import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  Button,
} from "@mui/material";

const getMessageFromType = (type) => {
  switch (type) {
    case "Invalid User Story":
      return "The file is empty or has no valid content. Please review and try again.";
    case "Unsupported format":
      return "The uploaded file format isn’t supported. Please try again";
    case "File Size":
      return "File Size has been exceeded. Please upload a file smaller than 50MB.";
    case "Invalid Figma URL":
      return "The Figma URL provided is invalid. Please check the link and try again.";
    default:
      return "The user story input you provided is not valid. Please revise it and try again.";
  }
};

const ValidationPopup = ({ open, onClose, messageType }) => {
  const message = getMessageFromType(messageType);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          minWidth: "400px",
          padding: "20px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "20px",
          paddingBottom: "10px",
          fontFamily: "Roboto, sans-serif",
        }}
      >
        Invalid User Story Input
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: "20px" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto, sans-serif",
            color: "#333",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: "flex-end", padding: "10px 24px" }}>
        <Button
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "14px",
            fontFamily: "Roboto, sans-serif",
            color: "white",
            backgroundColor: "#49A3FF",
            display: "flex",
            alignItems: "center",
            padding: "5px 15px",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationPopup;
